import React, { Suspense, useEffect, useState } from 'react';
import { useModules } from '@go-client/go-modules/core/ModuleContext';
import { Route, RouteProps } from 'react-router-dom';
import { GoModule } from '@go-shared/types/go-modules/goModules';
import { WithUserInfo } from '@go-client/context/UserInfoContext';
import { WithServerInfo } from '@go-client/context/ServerInfoContext';
import DisabledModule from '@go-client/go-modules/core/DisabledModule';
import { BubbleLoader } from '@go-client/components/BubbleUI';

export interface ModuleRoutesProps {
  modules: GoModule[];
}

export default () => {
  const { modules } = useModules();

  return (
    <>
      <WithServerInfo>
        <WithUserInfo>
          <ModuleRoutes modules={modules}></ModuleRoutes>
        </WithUserInfo>
      </WithServerInfo>
    </>
  );
};

class ModuleRoutes extends React.Component<ModuleRoutesProps & RouteProps> {
  public render() {
    const modules = this.props.modules;

    console.log(`[Module Routes] modules`, modules);

    return modules
      .filter(module => module.component.url)
      .map(module => (
        <Route
          exact
          key={module.name}
          path={module.component.url}
          render={_props => <GoModule moduleName={module.name} />}
        />
      ));
  }
}

interface GoRoutedModuleProps {
  moduleName: string;
}

const GoModule: React.FC<GoRoutedModuleProps> = (props: GoRoutedModuleProps) => {
  const { moduleName } = props;

  const { modules } = useModules();
  const [hasError, setHasError] = useState<string | null>(null);
  const [activated, setActivated] = useState<boolean>(false);

  useEffect(() => {
    const initializeModule = async () => {
      console.log(`[GoModule] Initializing ${moduleName}`);
      try {
        // 1. search module
        const module = modules.find(p => p.name === moduleName)!;

        // 2. activate before render
        await module.componentInstance?.activate();
        setActivated(true);
      } catch (error) {
        console.error(`[GoModule] Error activating module ${moduleName}: ${error}`);
        setHasError(`${error}`);
      }
    };

    initializeModule();
  }, [moduleName]);

  const module = modules.find(p => p.name === moduleName)!;

  if (hasError) {
    return <div style={{ color: 'red' }}>{hasError}</div>;
  }

  if (!module || !module.enabled) {
    console.error(`[GoModule] Module ${moduleName} disabled`);

    return <DisabledModule name={moduleName} />;
  } else if (!activated) {
    return <BubbleLoader />;
  } else {
    return (
      <>
        <Suspense fallback={<div>Loading module {moduleName}...</div>}>
          {module.componentInstance?.renderFn()}
        </Suspense>
      </>
    );
  }
};
